// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectAlgorithmMessageBase } from './DirectAlgorithmMessageBase';
import { Message } from './../Message';
export class DirectAlgorithmHighLowMessage extends DirectAlgorithmMessageBase {
    constructor() {
        super(Message.CODE_PFIX_ALGORITHM_HIGH_LOW_MESSAGE);
        this.HighLowItems = [];
    }
}
